const SUPABASE_URL = 'https://jtitgxdptkpnsqhuqavh.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp0aXRneGRwdGtwbnNxaHVxYXZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM0NjY1MzksImV4cCI6MjA5OTA0MjUzOX0.DgJkUWXhWngeaWAxpaK4PiC7Ilg1dPIYDiDdbbkjpRQ';
const VISITOR_KEY = 'sc_visitor_id';

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);

    if (!id) {
      id = `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }

    return id;
  } catch (e) {
    return `visitor_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }
}

function getRegionFromCountryCode(countryCode) {
  const code = String(countryCode || '').toUpperCase();

  const gcc = ['QA', 'AE', 'SA', 'KW', 'BH', 'OM'];
  const europe = ['PT', 'ES', 'FR', 'IT', 'DE', 'NL', 'BE', 'DK', 'SE', 'NO', 'FI', 'IE', 'GB', 'CH', 'AT', 'PL', 'CZ', 'GR'];
  const northAmerica = ['US', 'CA'];
  const asia = ['JP', 'KR', 'CN', 'HK', 'SG', 'MY', 'TH', 'ID', 'PH', 'VN'];

  if (gcc.includes(code)) return 'GCC';
  if (europe.includes(code)) return 'Europe';
  if (northAmerica.includes(code)) return 'North America';
  if (asia.includes(code)) return 'Asia';

  return code ? 'Other' : 'Unknown';
}

async function trackProductView(container) {
  if (!container) return;

  const productId = container.dataset.productId;
  if (!productId) return;

  const sessionKey = `sc_product_viewed_${productId}`;

  try {
    if (sessionStorage.getItem(sessionKey)) return;
    sessionStorage.setItem(sessionKey, 'true');
  } catch (e) {}

  const payload = {
    shopify_product_id: String(productId),
    product_title: container.dataset.productTitle || '',
    product_vendor: container.dataset.productVendor || '',
    product_url: container.dataset.productUrl || '',
    visitor_id: getVisitorId(),
    source_page: window.location.pathname,
    source_url: window.location.href,
    referrer: document.referrer || null,
    country_code: container.dataset.countryCode || null,
    country: container.dataset.countryName || null,
    market_handle: container.dataset.marketHandle || null,
    region: getRegionFromCountryCode(container.dataset.countryCode),
    viewed_at: new Date().toISOString()
  };

  try {
    const response = await fetch(`${SUPABASE_URL}/rest/v1/product_view_events`, {
      method: 'POST',
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
        Prefer: 'return=minimal'
      },
      body: JSON.stringify(payload),
      keepalive: true
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('SC product view insert failed:', errorText);
    }
  } catch (error) {
    console.error('SC product view tracking failed:', error);
  }
}

const productViewContainer = document.querySelector('[data-sc-product-view]');
trackProductView(productViewContainer);